import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  mode: 'runOnceForAllItems',
  code: `// Available variables:
// - items: Array of all input items
// - $input: Input data from previous node
// - $node: Access previous node outputs
// - $vars: Workflow variables

// Transform the data and return
return items.map(item => ({
  ...item,
  processed: true
}));`,
  language: 'javascript',
  executionTier: 'sandboxed',
};

export default defaults;
